import React, { ChangeEvent } from 'react';
import { Card } from 'components/Card';
import { InputFormField } from 'components/InputFormField';
import { InputImage } from 'components/InputImage';
import { SelectModified } from 'components/SelectModified';
import { Separator } from 'components/Separator';
import { Button } from 'components/Button';

import default_avatar from 'assets/imgs/img_sellers_identity/default_avatar.png'

import {
  OutSideContainer,
  CardItem,
  Container,
  Wrapper,
  Subtitle,
  LogoCard,
  ImageDetails,
  ImagePreview,
  SocialMediaBox,
  SessionContainer,
  ContactContainer,
  Content,
  MessageAlert,
  BusinessTrustCard,
  SideContainer,
  CardStatus,
} from './styles';
import { RadioButton } from 'components/RadioButton';
import { Title } from 'components/Title';
import { convertDateToShowInput } from 'utils/formattingInputs';
import { maskCNPJ, variablePhoneMask } from 'utils/masks';
import { TextFormField } from 'components/TextFormField';
import { FormikErrors, FormikTouched } from 'formik';
import { iconWhiteTrash } from 'assets/icons';
import { Footer } from 'components/Footer';
import { Badge } from 'components/Badge';
import { PlaceHolderNotExists } from 'components/PlaceholderNotExists';
import { Loading } from 'components/Loading';

export interface ContactProps {
  leadContactId?: number,
  contactTypeId: number,
  contact?: string,
  title?: string,
}

export interface ContactTypeProps {
  leadContactId?: number,
  contactTypeId: number,
  contactType: string,
}

export interface SocialMediaProps {
  contact: string,
  contactTypeId: number,
}

export interface LeadProps {
  leadId?: number,
  clearsaleEntityId?: string,

  firstname: string,
  email: string,
  cnpj: string,
  company: string,
  website: string,
  logo: string,
  phone: string,
  ramal?: string,
  socialMediaLink?: string,
  segmentId?: number,
  ecommercePlatformId?: number,
  billingRangeId?: number,
  amountRangeId?: number,
  cnpjStatus?: string,
  reprovedReason?: string,
  score?: string,
  riskSuggestion?: string,
  leadStatusId?: number,
  insertDate?: string,
  updateDate?: string,
  origin?: string,
  userId: number,
  address?: {
    address: string,
    addressNumber: string,
    zipcode: string,
    district: string,
    state: string,
    city: string,
  },
  contacts: ContactProps[],
  socialMedias?: SocialMediaProps[],
}

interface ContactSocialMediaType {
  contactTypeId: number,
  contactType: string
}

export interface CheckListProps {
  complianceStepid: number,
  complianceStep: string,
  expectedAnswer: string,
}

interface BillingRange {
  id: string,
  description: string,
}

interface AmountRange {
  id: string,
  description: string,
  sellerClassification: string,
}

interface EcommercePlatform {
  id: string,
  description: string,
}

interface Segment {
  id: string,
  description: string,
}

export interface UserAnswerIsExactProps {
  leadId: number,
  complianceStepId: number,
  status: boolean,
  beginDate?: string,
  endDate?: string,
  user?: string,
  observation?: string
}


export interface SellersLeadPropertiesResponse {
  billingRange: BillingRange[],
  amountRange: AmountRange[],
  ecommercePlatform: EcommercePlatform[],
  segment: Segment[],
  contactSocialMediaType: ContactSocialMediaType[],
  contactType: ContactTypeProps[];
}

export interface SocialMediaDictionary {
  [name: string]: string,
}

export interface StatusAnalysisLeadProps {
  leadStatusId: number,
  leadStatus: string
}

export interface StatusUsernameLeadProps {
  userId: number,
  userName: string
}

export interface OptionsSelectProps {
  value: string,
  label: string,
}

export interface ShowCardProps {
  card: string,
  leadStatusId?: number,
}

export interface DefineStatusLead {
  title: string,
  description: string,
  reason?: string
  status?: "reproved" | "approved",
}

export type DefaultStatusLead = "business-trust" | "reproved" | "approved"

interface SellerLeadFormProps {
  handleChangeRadioOfChecklist?: (event: ChangeEvent<HTMLInputElement>) => void,
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void,
  handleSelectChange: (event: ChangeEvent<HTMLSelectElement>) => void,
  handlerImageSelected: (event: React.ChangeEvent<HTMLInputElement>) => void,
  handleRemoveContact: (contactIndex: number) => void,
  handleAddContact: () => void,
  showAlertForm: (typeOpen: boolean) => void,
  changeNameTag: (props: string) => string | undefined,
  setReasonToLeadReproved: (props: string) => void,
  handleSubmit: () => void,
  setStatusToLead: (status: DefaultStatusLead) => void,
  checklist: CheckListProps[],
  inputsValues: LeadProps,
  initialInputsValues?: LeadProps,
  socialMediaTypes: ContactTypeProps[] | undefined,
  contactTypes: ContactTypeProps[],
  touched: any,
  errors: any,
  properties: SellersLeadPropertiesResponse,
  imagePath: string,
  reasonToLeadReproved?: string,
  socialMedias: SocialMediaDictionary,
  changeFooter: string[],
  submitButton: boolean,
  hasError: boolean,
  logoIsPNG: boolean,
  isLoading: boolean,
  statusAnalysisLead: StatusAnalysisLeadProps[],
  usersOptions: StatusUsernameLeadProps[],
  category: string,
  checkListStatus?: boolean,
  businnesTrust?: boolean,
  loadBusinessTrust?: boolean,
  showCard?: ShowCardProps,
  checklistAnswered?: UserAnswerIsExactProps[],
}

export const SellerLeadForm: React.FC<SellerLeadFormProps> = ({
  handleChangeRadioOfChecklist,
  handleChange,
  handleSelectChange,
  socialMediaTypes,
  checklist,
  inputsValues,
  initialInputsValues,
  touched,
  errors,
  properties,
  imagePath,
  handlerImageSelected,
  socialMedias,
  handleRemoveContact,
  handleAddContact,
  changeFooter,
  showAlertForm,
  submitButton,
  changeNameTag,
  handleSubmit,
  hasError,
  isLoading,
  statusAnalysisLead,
  usersOptions,
  category,
  checklistAnswered,
  showCard,
  loadBusinessTrust,
  setStatusToLead,
  reasonToLeadReproved,
  setReasonToLeadReproved,
  logoIsPNG
}) => {

  if (isLoading) {
    return <Loading />
  }

  if (hasError) {
    return (
      <PlaceHolderNotExists title="Erro ao tentar conectar com o servidor" />
    )
  }
  const isReadOnly = inputsValues.leadStatusId === 1 || inputsValues.leadStatusId === 2;
  return (
    <>
      <OutSideContainer>
        <div className="select-container">
          <SelectModified
            name="userId"
            label="Responsável"
            options={usersOptions.map(item => ({ value: String(item.userId), label: item.userName }))}
            onChange={handleSelectChange}
            value={String(inputsValues.userId)}
            error={!!touched.userId && !!errors.userId}
            errorMessage='Inserir nome do operador responsável'
            readOnly={isReadOnly}
            block
          />
          {!!inputsValues.leadStatusId &&
            <SelectModified
              name="leadStatusId"
              label="Status"
              options={statusAnalysisLead.map(item => ({ value: String(item.leadStatusId), label: item.leadStatus }))}
              onChange={handleSelectChange}
              value={String(inputsValues.leadStatusId) || "5"}
              error={touched.leadStatusId && !!errors.leadStatusId}
              errorMessage='Inserir status do cadastro'
              readOnly
              block
            />
          }
        </div>

        {!!inputsValues?.origin &&
          <CardItem>
            Origem: {inputsValues.origin}
          </CardItem>
        }

        {!!inputsValues?.insertDate &&
          <CardItem>
            Cadastro em: {convertDateToShowInput(inputsValues.insertDate)}
          </CardItem>
        }

        {category &&
          <CardItem>
            Categoria: {category}
          </CardItem>
        }
      </OutSideContainer>

      <Container>
        <SideContainer>
          <form onSubmit={handleSubmit}>
            <Card title="Dados cadastrais" typography="subtitle-medium">
              <Wrapper>
                <InputFormField
                  name="firstname"
                  label="Nome do responsável"
                  error={touched.firstname && !!errors.firstname}
                  mensageError="Inserir nome do responsável"
                  value={inputsValues.firstname}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  block
                />

                <InputFormField
                  name="company"
                  label="Nome da loja"
                  error={touched.company && !!errors.company}
                  mensageError="Inserir nome da empresa"
                  value={inputsValues.company}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  block
                />
              </Wrapper>

              <Wrapper>
                <InputFormField
                  name="email"
                  label="Email"
                  error={touched.email && !!errors.email}
                  mensageError="Inserir email válido"
                  value={inputsValues.email}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  block
                />

                <InputFormField
                  name="phone"
                  label="Telefone"
                  error={touched.phone && !!errors.phone}
                  mensageError="Inserir telefone"
                  value={inputsValues.phone}
                  onChange={handleChange}
                  mask={variablePhoneMask}
                  readOnly={isReadOnly}
                  block
                />
              </Wrapper>

              <Separator maxWidth="100%" marginY="0" />
              <Subtitle>Sobre a loja</Subtitle>
              <Wrapper>
                <InputFormField
                  name="cnpj"
                  label="CNPJ"
                  error={!!touched.cnpj && !!errors.cnpj}
                  mensageError="Inserir CNPJ válido"
                  value={inputsValues.cnpj}
                  onChange={handleChange}
                  mask={maskCNPJ}
                  readOnly={isReadOnly}
                  block
                />

                <InputFormField
                  name="website"
                  label="URL da loja"
                  error={touched.website && !!errors.website}
                  mensageError="Inserir website"
                  value={inputsValues.website}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  block
                />
              </Wrapper>

              <Wrapper className="select-container">
                <SelectModified
                  name="segmentId"
                  label="Categoria"
                  value={String(inputsValues.segmentId)}
                  errorMessage="Inserir categoria válida"
                  error={touched.segmentId && !!errors.segmentId}
                  onChange={handleSelectChange}
                  block={true}
                  readOnly={isReadOnly}
                  options={
                    properties?.segment?.map((segment) => {
                      return {
                        label: segment.description ?? '',
                        value: segment.id
                      }
                    }) ?? []
                  }
                />

                <SelectModified
                  name="ecommercePlatformId"
                  label="Plataforma"
                  value={String(inputsValues.ecommercePlatformId)}
                  errorMessage="Inserir plataforma válida"
                  error={touched.ecommercePlatformId && !!errors.ecommercePlatformId}
                  onChange={handleSelectChange}
                  block={true}
                  readOnly={isReadOnly}
                  options={
                    properties?.ecommercePlatform?.map((platform) => {
                      return {
                        label: platform.description ?? '',
                        value: platform.id
                      }
                    }) ?? []
                  }
                />

              </Wrapper>

              <Wrapper className="select-container">
                <SelectModified
                  name="amountRangeId"
                  label="Quantidade de vendas / mês"
                  value={String(inputsValues.amountRangeId)}
                  errorMessage="Inserir quantidade válida"
                  error={touched.amountRangeId && !!errors.amountRangeId}
                  onChange={handleSelectChange}
                  block={true}
                  readOnly={isReadOnly}
                  options={
                    properties?.amountRange?.map((amountRange) => {
                      return {
                        label: amountRange.description,
                        value: amountRange.id
                      }
                    }) ?? []
                  }
                />
                <SelectModified
                  name="billingRangeId"
                  label="Faturamento mensal"
                  value={String(inputsValues.billingRangeId)}
                  errorMessage="Inserir faturamento válido"
                  error={touched.billingRangeId && !!errors.billingRangeId}
                  onChange={handleSelectChange}
                  block={true}
                  readOnly={isReadOnly}
                  options={
                    properties?.billingRange?.map((billingRange) => {
                      return {
                        label: billingRange.description,
                        value: billingRange.id
                      }
                    }) ?? []
                  }
                />
              </Wrapper>

              {inputsValues.leadId ?
                <>
                  <Separator maxWidth="100%" marginY="0" />
                  <Subtitle>Dados receita</Subtitle>

                  {inputsValues.cnpjStatus === "ATIVA" ?
                    <>
                      <Wrapper>
                        <InputFormField
                          name="address"
                          label="Logradouro"
                          value={inputsValues.address?.address}
                          block
                          readOnly
                          disabled
                        />

                        <InputFormField
                          name="addressNumber"
                          label="Número"
                          value={inputsValues.address?.addressNumber}
                          readOnly
                          disabled
                        />
                      </Wrapper>

                      <Wrapper>
                        <InputFormField
                          name="zipcode"
                          label="CEP"
                          value={inputsValues.address?.zipcode}
                          // mask={inputsValues.address?.zipcode && maskCEP}
                          readOnly
                          disabled
                        />

                        <InputFormField
                          name="district"
                          label="Bairro"
                          value={inputsValues.address?.district}
                          readOnly
                          disabled
                          block
                        />
                      </Wrapper>

                      <Wrapper>
                        <InputFormField
                          name="state"
                          label="UF"
                          value={inputsValues.address?.state}
                          readOnly
                          disabled
                        />

                        <InputFormField
                          name="city"
                          label="Município"
                          value={inputsValues.address?.city}
                          readOnly={true}
                          block
                          disabled
                        />
                      </Wrapper>

                      <InputFormField
                        name="state"
                        label="Situação cadastral"
                        readOnly={true}
                        value={inputsValues.cnpjStatus}
                        block
                        disabled
                      />
                    </>
                    : <MessageAlert>
                      Dados inválidos!
                      <p>{!!inputsValues.cnpjStatus && `Situação do CNPJ: ${inputsValues.cnpjStatus}`}</p>
                    </MessageAlert>
                  }
                </>
                : ""}

              <Separator maxWidth="100%" marginY="0" />
              <Subtitle>Logo</Subtitle>

              <LogoCard>
                <ImagePreview
                  imageUrl={imagePath ?? inputsValues.logo ?? default_avatar}
                />
                <ImageDetails>
                  <span>Sempre que possível utilize um arquivo <br />de proporção 1:1</span>
                  <InputImage
                    error={!!touched.logo && !!errors.logo}
                    errorMessage='Nenhuma imagem encontrada'
                    errorByTypeImage={!logoIsPNG && !!imagePath}
                    errorMessageByTypeImage="Por favor, utilize arquivos em .PNG"
                    onChange={handlerImageSelected}
                    disabled={isReadOnly}
                  />
                </ImageDetails>
              </LogoCard>

              <Separator maxWidth="100%" marginY="0" />
              <Subtitle>Redes sociais</Subtitle>

              {inputsValues.leadId ?
                <TextFormField
                  name="socialMediaLink"
                  label=""
                  value={inputsValues.socialMediaLink && inputsValues.socialMediaLink.replaceAll(" ", "\n")}
                  onChange={handleChange}
                  block
                  readOnly={true}
                />
                : ""}

              {/* Falta finalizar implementação da logica de midias sociais */}
              {socialMediaTypes?.map((item, index) => {
                return (
                  <Wrapper key={index}>
                    <SocialMediaBox>
                      <img
                        src={socialMedias[item.contactType.toLowerCase()] || ''}
                        alt={socialMedias[item.contactType.toLowerCase()] || ''}
                      />
                    </SocialMediaBox>

                    <InputFormField
                      name={`socialMedias[${index}].contact`}
                      label="URL"
                      autoComplete='off'
                      value={inputsValues.socialMedias ? inputsValues.socialMedias[index]?.contact : ''}
                      onChange={handleChange}
                      readOnly={isReadOnly}
                      block
                    />
                  </Wrapper>
                )
              })}

              <Separator maxWidth="100%" marginY="0" />
              <SessionContainer>
                <Subtitle>Contatos de suporte</Subtitle>
                <Button
                  label="Adicionar novo contato"
                  typeBtn="blue"
                  type="button"
                  onClick={handleAddContact}
                  disabled={isReadOnly}
                  size="medium"
                />
              </SessionContainer>

              {inputsValues.contacts.map((_, index) => {
                const touchedCotacts = touched.contacts?.[index] as FormikTouched<ContactProps>;
                const errorsCotacts = errors.contacts?.[index] as FormikErrors<ContactProps>;
                return <ContactContainer
                  key={index}
                  className="buttom-remove-contact"
                >
                  <Wrapper>
                    <InputFormField
                      name={`contacts[${index}].title`}
                      label="Título"
                      value={inputsValues.contacts[index]?.title}
                      onChange={handleChange}
                      readOnly={isReadOnly}
                      error={(!!touchedCotacts?.title && !!errorsCotacts?.title)}
                      mensageError="Título inválido"
                      block
                    />
                    {index === 0 ? "" :
                      <Button
                        label=""
                        typeBtn="danger"
                        onlyIcon={true}
                        size="large"
                        icon={iconWhiteTrash}
                        className="remove-contact"
                        onClick={() => handleRemoveContact(index)}
                        disabled={isReadOnly}
                      />
                    }
                  </Wrapper>

                  <Wrapper className="select-container">
                    <SelectModified
                      name={`contacts[${index}].contactTypeId`}
                      label="Tipo de contato"
                      value={String(inputsValues.contacts[index]?.contactTypeId)}
                      onChange={(event) => {
                        inputsValues.contacts[index].contact = '';
                        handleSelectChange(event);
                      }}
                      readOnly={isReadOnly}
                      error={(!!touchedCotacts?.contactTypeId && !!errorsCotacts?.contactTypeId)}
                      errorMessage="Tipo de contato inválido"
                      options={
                        properties?.contactType?.map((contactType) => {
                          return {
                            label: contactType.contactType ?? '',
                            value: String(contactType.contactTypeId)
                          }
                        }) ?? []
                      }
                      block
                    />
                    <InputFormField
                      name={`contacts[${index}].contact`}
                      label="Contato"
                      value={inputsValues.contacts[index]?.contact}
                      onChange={handleChange}
                      error={(!!touchedCotacts?.contact && !!errorsCotacts?.contact)}
                      mask={
                        properties?.contactType?.find((contactType) => 
                          contactType.contactTypeId == inputsValues.contacts[index]?.contactTypeId
                        )?.contactType.toLowerCase() === 'telefone'
                          ? variablePhoneMask
                          : undefined}
                      mensageError="Contato inválido"
                      marginBotton="0"
                      readOnly={isReadOnly}
                      block
                    />
                  </Wrapper>
                  {index < inputsValues.contacts.length - 1 && <Separator maxWidth="100%" marginY="0" />}
                </ContactContainer>
              })}
            </Card>
          </form>
        </SideContainer>

        {inputsValues.leadId ?
          <SideContainer>
            {initialInputsValues?.userId ?
              <>
                {showCard?.card === "REPROVED_BY_CNPJ" && inputsValues.leadStatusId !== 2
                  ?
                  <Content id="invalid-data">
                    <Card
                      title="Reprovação por dados inválidos"
                      typography="subtitle-medium"
                    >
                      <Button
                        typeBtn="blue"
                        label="Reprovar varejista"
                        onClick={() => setStatusToLead("reproved")}
                        size="small"
                        block
                      />
                    </Card>
                  </Content>
                  : ""}

                {(inputsValues.leadStatusId === 3 && (showCard?.card === "APPROVED_BY_CNPJ" || showCard?.card === "REPROVED_BY_CHECKLIST" || showCard?.card === "APPROVED_BY_CHECKLIST")) ?
                  <Content id="checklist">
                    {checklist.length ?
                      <Card title="Segundo sua avaliação, esta loja:" typography="subtitle-medium">

                        {checklist.filter((itemFilttered) => itemFilttered.expectedAnswer === "Sim").map((item, index) => (
                          <>
                            <Wrapper>
                              <span>{item.complianceStep}</span>
                              <span>
                                <RadioButton
                                  id={`${item.complianceStepid}_yes`}
                                  name={String(item.complianceStepid)}
                                  label="Sim"
                                  value="Sim"
                                  defaultChecked={checklistAnswered && checklistAnswered.find(data => data.complianceStepId === item.complianceStepid)?.status === true}
                                  onChange={handleChangeRadioOfChecklist}
                                />
                                <RadioButton
                                  id={`${item.complianceStepid}_no`}
                                  name={String(item.complianceStepid)}
                                  label="Não"
                                  value="Não"
                                  defaultChecked={checklistAnswered && checklistAnswered.find(data => data.complianceStepId === item.complianceStepid)?.status === false}
                                  onChange={handleChangeRadioOfChecklist}
                                />
                              </span>
                            </Wrapper>
                            {index === checklist.filter(item => item.expectedAnswer === "Sim").length - 1 ? "" : <Separator maxWidth="100%" marginY="0" />}
                          </>
                        ))}

                        <Subtitle>Considerando os produtos, esta loja:</Subtitle>

                        {checklist.filter(itemFilttered => itemFilttered.expectedAnswer === "Não").map((item, index) => (
                          <>
                            <Wrapper>
                              <span>{item.complianceStep}</span>
                              <span>
                                <RadioButton
                                  id={`${item.complianceStepid}_yes`}
                                  name={String(item.complianceStepid)}
                                  label="Sim"
                                  value="Sim"
                                  defaultChecked={checklistAnswered && checklistAnswered.find(data => data.complianceStepId === item.complianceStepid)?.status === false}
                                  onChange={handleChangeRadioOfChecklist}
                                />
                                <RadioButton
                                  id={`${item.complianceStepid}_no`}
                                  name={String(item.complianceStepid)}
                                  label="Não"
                                  value="Não"
                                  defaultChecked={checklistAnswered && checklistAnswered.find(data => data.complianceStepId === item.complianceStepid)?.status === true}
                                  onChange={handleChangeRadioOfChecklist}
                                />
                              </span>
                            </Wrapper>
                            {index === checklist.filter(item => item.expectedAnswer === "Não").length - 1 ? "" : <Separator maxWidth="100%" marginY="0" />}
                          </>
                        ))}

                      </Card>
                      : ""}
                  </Content>
                  : ""}

                {showCard?.card === "APPROVED_BY_CHECKLIST" ?
                  <Content id="approved-by-checklist">
                    <Card
                      title="Esta loja está apta a fazer parte da Confi?"
                      typography="subtitle-medium"
                    >
                      <Wrapper>
                        <Button
                          typeBtn="blue"
                          label="Sim"
                          onClick={() => setStatusToLead("business-trust")}
                          size="small"
                          block
                        />
                        <Button
                          typeBtn="outline"
                          label="Não"
                          onClick={() => setStatusToLead("reproved")}
                          size="small"
                          block
                        />
                      </Wrapper>
                    </Card>
                  </Content>
                  : ""}

                {((inputsValues.leadStatusId === 4 && showCard?.card === "BUSINESS_TRUST")
                  || (inputsValues.leadStatusId === 2 && showCard?.card === "REPROVED"))
                  && inputsValues.score ?
                  <Content id="business-trust">
                    <>
                      <Card
                        title="Business Trust"
                        typography="subtitle-medium"
                      >
                        <Title
                          elementHTML="strong"
                          className="subtitle-small"
                          text="Avaliação automática"
                        />
                        <Wrapper>
                          <BusinessTrustCard>
                            <span>Score</span>
                            <div className="data-container">
                              <h2>{Number(inputsValues.score).toFixed(2)}</h2>
                            </div>
                          </BusinessTrustCard>
                          <BusinessTrustCard>
                            <span>Sugestão</span>
                            <div className="data-container">
                              <h2>{inputsValues.riskSuggestion}</h2>
                              <Button
                                className="button-link"
                                typeBtn="blue"
                                size="small"
                                load={loadBusinessTrust}
                                block
                                label="Avaliação manual"
                                onClick={() => { }} //FUNCIONALIDADE AINDA NÃO ESTÁ DEFINIDA NO TIME DE NEGÓCIOS
                                disabled
                              />
                            </div>
                          </BusinessTrustCard>
                        </Wrapper>
                      </Card>
                    </>
                  </Content>
                  : ""}

                {inputsValues.leadStatusId === 4 && showCard?.card === "BUSINESS_TRUST" &&
                  <Content>
                    <Card
                      title="Aprovação"
                      typography="subtitle-medium"
                    >
                      <strong className='warning'>Atenção! Essa ação não pode ser revertida.</strong>
                      <Button
                        typeBtn="blue"
                        label="Aprovar lead"
                        onClick={() => setStatusToLead("approved")}
                        size="small"
                        block
                      />
                    </Card>
                  </Content>
                }

                {inputsValues.leadStatusId === 2 ?
                  <Content id="invalid-data">
                    <CardStatus>
                      <strong>Loja
                        <span className="disapproved"> reprovada </span>
                        por {usersOptions.find(item => item.userId === inputsValues.userId)?.userName} em {convertDateToShowInput(inputsValues.updateDate)}.
                      </strong>
                    </CardStatus>
                  </Content>
                  : ""}
              </>
              : ""}

            {showCard?.card === "REPROVED_BY_CHECKLIST" || showCard?.card === "BUSINESS_TRUST" || inputsValues.reprovedReason ?
              <Content id="refused">
                <Card
                  title="Reprovação"
                  typography="subtitle-medium"
                >
                  <Title
                    elementHTML="strong"
                    className="subtitle-small"
                    text="Motivo da reprovação"
                  />

                  <TextFormField
                    name="reasonToReproved"
                    label=""
                    value={inputsValues.reprovedReason ? inputsValues.reprovedReason : reasonToLeadReproved}
                    onChange={(e) => setReasonToLeadReproved(e.target.value)}
                    block
                    disabled={!!inputsValues.reprovedReason}
                  />

                  {!inputsValues.reprovedReason &&
                    <Button
                      typeBtn="blue"
                      label="Reprovar varejista"
                      onClick={() => setStatusToLead("reproved")}
                      disabled={!reasonToLeadReproved}
                      size="small"
                      block
                    />
                  }
                </Card>
              </Content>
              : ""}
          </SideContainer>
          : ""}

        <Footer>
          {inputsValues.leadId ?
            <>
              <Title elementHTML="strong" text="Campos atualizados:" className="tag" />
              {changeFooter.map((item: string, index) => (item ? <Badge value={changeNameTag(item) || ""} key={item} /> : null))}
            </>
            : ""}

          <Button type="button" label="Descartar" size="medium" typeBtn="outline" onClick={() => showAlertForm(false)} />

          <Button type="button" label={inputsValues.leadId ? "Atualizar dados" : "Cadastrar"} size="medium" typeBtn="blue" disable={submitButton} onClick={() => showAlertForm(true)} />

        </Footer>
      </Container>
    </>
  );
}
